import React from 'react'
import ValuationItem from '@components/ValuationItem'
import {
  List,
  Item,
  ItemHeader,
  ItemHeaderGreenBall,
  ItemHeaderDate,
  ItemBody,
} from './styles'
import { filterValuations, orderValuations } from '../../utils/historicHelper'

const HistoricList = ({
  valuations,
  selectedMonth,
  setSelectedValuationId,
}) => {
  const renderListItems = () => {
    const filtered = filterValuations(valuations, selectedMonth)
    return filtered.map(month => {
      const orderByDay = orderValuations(filtered)[0]
      return orderByDay.map(day => (
        <Item key={`${month?.year}-${day[0]}-${month?.month}`}>
          <ItemHeader>
            <ItemHeaderGreenBall />
            <ItemHeaderDate>
              {month?.year}, {day[0]} {month?.month}
            </ItemHeaderDate>
          </ItemHeader>
          <ItemBody>
            {day[1]?.map(valuation => (
              <ValuationItem
                setSelectedValuationId={setSelectedValuationId}
                key={valuation?.id}
                valuation={valuation}
              />
            ))}
          </ItemBody>
        </Item>
      ))
    })
  }
  return <List>{renderListItems()}</List>
}

export default HistoricList
